export const DEFAULT_JOB_FINISHED_SMS_TEMPLATE =
  "Hi {customer}, your {racketType} racket is ready for pickup. Thank you!";

export const JOB_FINISHED_SMS_PLACEHOLDERS_HELP =
  "Supported placeholders: {customer}, {racket}, {racketType}.";
